<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import Button from 'dashboard/components-next/button/Button.vue';
import FilterSelect from '../../socialMonitoring/components/FilterSelect.vue';

defineProps({
  generating: { type: Boolean, default: false },
});
const emit = defineEmits(['generate']);

const store = useStore();
const query = ref('');
const state = ref('');
const results = ref([]);
const searching = ref(false);
const picked = ref(null);

const UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];
const ufOptions = [
  { value: '', label: 'Qualquer UF' },
  ...UFS.map(u => ({ value: u, label: u })),
];

async function doSearch() {
  if (!query.value || query.value.length < 3) return;
  searching.value = true;
  try {
    results.value = await store.dispatch('electoralCampaign/searchCity', {
      q: query.value,
      state: state.value,
    });
  } finally {
    searching.value = false;
  }
}
function pick(r) {
  picked.value = r;
  query.value = r.nome;
  state.value = r.uf;
  results.value = [];
}
function submit() {
  if (!picked.value) return;
  emit('generate', { city: picked.value.nome, state: picked.value.uf });
}
</script>

<template>
  <div
    class="rounded-xl border border-n-strong/40 bg-gradient-to-br from-indigo-50 to-blue-50 p-6"
  >
    <div class="mb-4 flex items-start gap-3">
      <div
        class="flex size-10 items-center justify-center rounded-lg bg-blue-600 text-white"
      >
        <span class="i-lucide-map size-5" />
      </div>
      <div>
        <h3 class="text-base font-bold text-n-slate-12">
          Gerar mapa do município
        </h3>
        <p class="text-xs text-n-slate-11">
          Busca o contorno real no IBGE + bairros do OpenStreetMap e gera um SVG
          inteligente.
        </p>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-3 md:grid-cols-[1fr_auto]">
      <div class="space-y-2">
        <div class="flex gap-2">
          <input
            v-model="query"
            type="text"
            placeholder="Digite o nome do município (ex.: Barueri)"
            class="flex-1 rounded-lg border border-n-strong/40 bg-n-background px-3 py-2 text-sm"
            @keydown.enter.prevent="doSearch"
          />
          <FilterSelect
            v-model="state"
            :options="ufOptions"
            placeholder="UF"
            min-width="90px"
          />
          <Button
            variant="outline"
            size="sm"
            icon="i-lucide-search"
            :is-loading="searching"
            @click="doSearch"
          >
            Buscar
          </Button>
        </div>

        <div
          v-if="results.length"
          class="rounded-lg border border-n-strong/40 bg-n-background"
        >
          <button
            v-for="r in results"
            :key="r.id"
            type="button"
            class="flex w-full items-center gap-2 border-b border-n-weak px-3 py-2 text-left text-sm hover:bg-n-slate-2"
            @click="pick(r)"
          >
            <span class="i-lucide-map-pin size-3.5 text-n-slate-11" />
            <span class="flex-1">{{ r.nome }}</span>
            <span
              class="rounded bg-n-slate-2 px-1.5 py-0.5 text-[10px] font-semibold text-n-slate-12"
            >
              {{ r.uf }}
            </span>
          </button>
        </div>

        <div
          v-if="picked"
          class="rounded-lg bg-emerald-50 px-3 py-2 text-xs text-emerald-700"
        >
          <span class="i-lucide-check-circle size-3.5 align-middle" />
          Selecionado: <strong>{{ picked.nome }} / {{ picked.uf }}</strong>
        </div>
      </div>

      <Button
        variant="solid"
        color="blue"
        size="md"
        icon="i-lucide-sparkles"
        :disabled="!picked"
        :is-loading="generating"
        @click="submit"
      >
        Gerar mapa
      </Button>
    </div>
  </div>
</template>
